<template>
  <div>
        <el-drawer title="Switch Company" :visible.sync="showCompanies" direction="btt" :before-close="handleClose" size="90%" :destroy-on-close="true">
          <div>
            <select-company></select-company>
          </div>

        </el-drawer>
        
    <navbar v-model="showNavbar" class="ticket-shipper-topbar">
      <div class="navbar-wrapper">
        <div class="navbar-minimize">
          <button
            id="minimizeSidebar"
            class="btn btn-icon btn-round ticket-shipper-topbar__sidebar"
            type="button"
            aria-label="Minimize sidebar"
            title="Minimize sidebar"
            @click="minimizeSidebar"
          >
            <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
            <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
          </button>
        </div>
        <div class="navbar-toggle">
          <navbar-toggle-button @click.native="toggleSidebar">

          </navbar-toggle-button>
        </div>
        <a class="navbar-brand ticket-shipper-topbar__brand" href="" aria-label="Weesam home">
          <span>{{ user && user.client ? user.client.name : '' }}</span> <span>{{ user && user.branch ? user.branch.name : '' }}</span>
        </a>
        <button
          type="button"
          class="ticket-shipper-topbar__theme"
          :aria-label="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
          :aria-pressed="theme === 'dark'"
          @click="toggleTheme"
        >
          <i :class="theme === 'dark' ? 'fa fa-sun-o' : 'fa fa-moon-o'" aria-hidden="true"></i>
          <span>Dark mode</span>
        </button>
      
      </div>

      <template slot="navbar-menu">
        <ul class="navbar-nav ticket-shipper-topbar__menu">
          <notification></notification>
          <li class="nav-item ticket-shipper-topbar__logout-item">
            <a class="nav-link btn-rotate ticket-shipper-topbar__logout" href="/logout" aria-label="Log out" title="Log out">
              <i class="fa fa-power-off" title="Logout"></i>
              <span class="ticket-shipper-topbar__logout-label">Log out</span>
            </a>
          </li>
        </ul>
      </template>
    </navbar>
  </div>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
  import { mapState } from 'vuex';
import Notification from './Notification.vue';
import SelectCompany from '../../Common/SelectCompany.vue';
  
  export default {
    components: {
      Navbar,
      NavbarToggleButton,
        Notification,
        SelectCompany
    },
    computed: {
      ...mapState(['user', 'theme'])
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        showCompanies: false
      }
  },
  methods: {
      toggleTheme() {
        this.$store.commit('setTheme', this.theme === 'dark' ? 'light' : 'dark')
      },
      hasCompany() {
          return this.user && this.user.company  
      },
      getPlan() {
        return this.hasCompany() ? this.user.company.plan : null
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
    },
      handleChangeCompany() {
        this.showCompanies = true
    },
    handleClose() {
        this.showCompanies = false
      }
    }
  }

</script>
<style lang="scss">
.ticket-shipper-topbar.navbar {
  min-height: 66px;
  padding: 0;
  border-bottom: 1px solid #e2e9e4;
  background: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 3px 12px rgba(28, 57, 70, 0.045);
}

.ticket-shipper-topbar .container-fluid {
  display: flex;
  min-height: 66px;
  align-items: center;
  padding: 0 24px;
}

.ticket-shipper-topbar .navbar-wrapper {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 14px;
}

.ticket-shipper-topbar .navbar-minimize {
  margin: 0;
}

.ticket-shipper-topbar .ticket-shipper-topbar__sidebar.btn {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  padding: 0;
  border: 1px solid #d9e8df;
  border-radius: 12px;
  color: #fff;
  background: #1b6f71;
  box-shadow: none;
  transition: transform 0.15s ease, background 0.15s ease;
}

.ticket-shipper-topbar .ticket-shipper-topbar__sidebar.btn:hover,
.ticket-shipper-topbar .ticket-shipper-topbar__sidebar.btn:focus {
  transform: translateX(-1px);
  border-color: #155c5e;
  background: #155c5e;
}

.ticket-shipper-topbar .ticket-shipper-topbar__brand {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
  color: #36525e;
  font-family: "Montserrat", "Muli", "Helvetica Neue", Arial, sans-serif;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 0.8px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ticket-shipper-topbar .ticket-shipper-topbar__brand span + span {
  margin-left: 7px;
  padding-left: 9px;
  border-left: 1px solid #dce6e0;
  color: #7a8c90;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
}

.ticket-shipper-topbar .ticket-shipper-topbar__menu {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.ticket-shipper-topbar__theme {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #dce6e0;
  border-radius: 10px;
  color: #50656c;
  background: #fff;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.ticket-shipper-topbar__theme:hover,
.ticket-shipper-topbar__theme:focus-visible {
  border-color: #1b6f71;
  color: #155c5e;
  outline: none;
}

.ticket-shipper-topbar__theme:disabled {
  cursor: wait;
  opacity: 0.65;
}

.ticket-shipper-topbar__theme > i {
  font-size: 15px;
}

.ticket-shipper-topbar .ticket-shipper-topbar__logout {
  display: inline-flex;
  min-width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 11px !important;
  border: 1px solid #e3eae5;
  border-radius: 10px;
  color: #667b82 !important;
  background: #fff;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.ticket-shipper-topbar .ticket-shipper-topbar__logout:hover {
  border-color: #e6d5d2;
  color: #9b514a !important;
  background: #fff9f7;
}

.ticket-shipper-topbar .ticket-shipper-topbar__logout > i {
  font-size: 16px;
}

.ticket-shipper-topbar .ticket-shipper-topbar__logout-label {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .ticket-shipper-topbar .container-fluid {
    padding: 0 15px;
  }

  .ticket-shipper-topbar .navbar-wrapper {
    gap: 9px;
  }

  .ticket-shipper-topbar .ticket-shipper-topbar__brand {
    font-size: 16px;
  }

  .ticket-shipper-topbar .ticket-shipper-topbar__brand span + span {
    font-size: 11px;
  }

  .ticket-shipper-topbar .ticket-shipper-topbar__logout-label {
    display: none;
  }

  .ticket-shipper-topbar .ticket-shipper-topbar__logout {
    width: 40px;
    padding: 0 !important;
  }

  .ticket-shipper-topbar__theme {
    min-height: 36px;
    gap: 5px;
    padding: 0 8px;
    font-size: 10px;
  }
}
</style>
